import React from 'react';
import ContactUsButton from '../components/ContactUsButton';
import FacilitySponsorBanner from '../components/FacilitySponsorBanner';
import { getFacilityDisplayName } from '../data/sponsors';

const WalkingTrackRulesPage: React.FC = () => {
  const trackName = getFacilityDisplayName('walking-track');

  return (
    <div className="page-container">
      <div className="services-page">
        <div className="services-container">
          <p className="breadcrumb">Services / {trackName}</p>
          <h1 className="page-title">{trackName}</h1>
          <p className="page-subtitle">
            Guidelines for using the indoor walking track at TDS Event Center.
          </p>
          <FacilitySponsorBanner facility="walking-track" />
          <div className="page-header-actions">
            <ContactUsButton
              buttonText="Click here to ask questions"
              className="contact-button contact-button-alt"
              defaultService={trackName}
              defaultInquiry="information"
            />
          </div>

          <div className="rules-section">
            <h2>General Usage</h2>
            <ul>
              <li>The walking track is open during posted facility hours and does not require a reservation.</li>
              <li>Walkers should follow the indicated direction of travel for the day, if posted.</li>
              <li>Please use appropriate walking or athletic shoes.</li>
            </ul>
          </div>

          <div className="rules-section">
            <h2>Safety &amp; Courtesy</h2>
            <ul>
              <li>Slower walkers should keep to the inside lanes; faster walkers may use outer lanes to pass.</li>
              <li>No stopping or standing in the middle of the track; move to the side if you need to stop.</li>
              <li>Children must be accompanied and supervised by an adult at all times.</li>
            </ul>
          </div>

          <div className="rules-section">
            <h2>Prohibited Activities</h2>
            <ul>
              <li>No food or open beverages on the track; bottled water with lids is allowed.</li>
              <li>Strollers, skates, scooters, and bicycles are not permitted.</li>
            </ul>
          </div>

        </div>
      </div>
    </div>
  );
};

export default WalkingTrackRulesPage;


